import React from 'react'

import MapModal from '../../components/maps/MapModal'
import {
  MobileSearchViewWrapper,
  ResultsWrapper,
} from '../../components/layout/ItemGridWithMap/Mobile'
import {
  Outerwrapper,
  StickyBar,
} from '../../components/layout/ItemGridWithMap/Desktop'

type MobileViewProps = {
  filterBarComponent: React.ReactNode
  resultsComponent: React.ReactNode
  mapComponent: React.ReactNode
}

const MobileView = ({
  filterBarComponent,
  resultsComponent,
  mapComponent,
}: MobileViewProps) => {
  return (
    <Outerwrapper className="js-global-loader-container">
      <StickyBar>{filterBarComponent}</StickyBar>
      <MobileSearchViewWrapper>
        <ResultsWrapper>{resultsComponent}</ResultsWrapper>
      </MobileSearchViewWrapper>

      <MapModal mapComponent={mapComponent} />
    </Outerwrapper>
  )
}

export default MobileView
